import { Callout } from '@blueprintjs/core';
import { useApplicationDetail } from '@axo/shared/data-access/hooks/queries/useApplicationDetail';
import { usePerson } from '@axo/shared/data-access/hooks/queries/usePerson';

export function CreditWarningBanner({
  applicationID,
}: {
  applicationID: string;
}) {
  const app = useApplicationDetail(applicationID);
  const mainApplicant = usePerson(app.data?.PersonID);
  const coApplicant = usePerson(app.data?.CoApplicantPersonID);

  const applicants = [
    mainApplicant.data?.CreditWarning && 'applicant',
    coApplicant.data?.CreditWarning && 'co-applicant',
  ].filter(Boolean);

  if (applicants.length === 0) return null;

  return (
    <Callout intent="danger" icon="warning-sign" title="Credit warning">
      The {applicants.join(' and the ')}{' '}
      {applicants.length > 1 ? 'have' : 'has'} an active credit warning. Bank
      partners won't pay out to applicants with a credit warning.
    </Callout>
  );
}
